export default __webpack_public_path__ + "fonts/Gotham-Bold.9fe4c8aa3bdd89a81727500e4b0d4703.woff2";